<template>
  <div v-if="me" class="the-navbar__user-meta flex items-center">
    <!-- <div class="text-right leading-tight hidden sm:block">
      <p v-if="me.consultant" class="font-semibold">
        {{ me.consultant.firstName }}
        {{ me.consultant.lastName }}
      </p>
    </div> -->
    <router-link
      class="consultant-image-file-link"
      :to="{
        name: 'consultant.edit',
        params: { id: me.consultant.id }
      }"
    >
      <MeImage :src="me.consultant.imageID" />
    </router-link>
    <!-- <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="me.consultant && me.consultant.image"
          key="onlineImg"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <FaIcon v-else icon="ellipsis-v" class="open-menu-icon" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            v-if="me.consultant"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <router-link
              :to="{
                name: 'consultant.edit',
                params: { id: me.consultant.id }
              }"
              class="hover:text-white w-full"
            >
              <feather-icon icon="user" svg-classes="w-4 h-4" />
              <span class="ml-2">Profil</span>
            </router-link>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="sign-out" svg-classes="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown> -->
    <button class="logout-button cursor-pointer" title="Logout" @click="logout">
      <feather-icon :icon="['fal', 'sign-out']" />
    </button>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { onLogout } from "@/vue-apollo";
import MeImage from "@/components/ui/MeImage";

export default {
  components: {
    MeImage
  },
  apollo: {
    me: gql`
      query {
        me {
          id
          consultant {
            id
            firstName
            lastName
            imageID
          }
        }
      }
    `
  },
  methods: {
    logout() {
      this.$store.commit("user/logout");
      onLogout(this.$apollo);
      this.$router.push("/pages/login").catch(() => {});
    }
  }
};
</script>
